module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_7.a4c0b465.jpg";